<template>
  <div v-if="hasLimitedRole">
    <v-tooltip v-if="useTooltip" bottom :disabled="false">
      <template #activator="{ on }">
        <v-list-item class="cursor-pointer" v-on="on">
          <v-list-item-icon>
            <v-icon small color="yellow darken-2">mdi-alert-circle-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="yellow--text text--darken-3">
              Viewer mode
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <span>Your current role on this account doesn't allow you <br> to create or save changes.</span>
    </v-tooltip>

    <template v-else>
      <v-list-item class="cursor-pointer" @click="roleWarningExpanded = !roleWarningExpanded">
        <v-list-item-icon>
          <v-icon small color="yellow darken-2">mdi-alert-circle-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="yellow--text text--darken-3">
            Viewer mode
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-icon small>
            {{ roleWarningExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
          </v-icon>
        </v-list-item-action>
      </v-list-item>

      <v-expand-transition>
        <div
          v-if="roleWarningExpanded"
          class="px-1 py-1 ml-1 warning-message"
        >
          <div class="caption">
            Your current role on this account doesn't allow you to create or save changes.
          </div>
        </div>
      </v-expand-transition>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    account: {
      type: Object,
      required: true,
    },
    useTooltip: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      roleWarningExpanded: false,
    }
  },
  computed: {
    hasLimitedRole() {
      return ['viewer', ''].includes(this.account.role)
    },
  },
}
</script>

<style scoped lang="scss">
.warning-message {
  background-color: #fff8e1;
  border-left: 4px solid #fbc02d;
  color: #f57c00;
}
.cursor-pointer {
  cursor: pointer;
}
</style>

